var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-24"},[_c('h1',[_vm._v("Not Found")]),_vm._v(" "),_c('p',[_vm._v("We're sorry but the page you're looking for wasn't found. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go home?")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }